import { Banner, List } from '@shopify/polaris'

type Props = { errors: string[] }

export function ValidationBanner({ errors }: Props) {
    if (errors.length === 0) return null
    return (
        <Banner tone="critical" title="Missing required fields">
            <List>
                {errors.map((err, i) => <List.Item key={i}>{err}</List.Item>)}
            </List>
        </Banner>
    )
}
